import React, { useState } from 'react'
import { Row, Container, Col, Image, Carousel, Button } from "react-bootstrap";
import { Link } from 'react-router-dom';

import sliderService1 from "../../Assets/services/slider-service-1.png";

const slides = [
    {
        badge: "DIRECT SELLING",
        title: "MLM Platform Engineering",
        subtitle:
            "Supporting systems where accuracy and consistency are critical.",
        description:
            "Enterprise MLM platforms with complex compensation logic, genealogy structures, and system integrations.",
        tags: [
            "Enrollment, genealogy and rep systems",
            "Compensation plans and autoship logic",
            "Backend, payment and tax integrations",
        ],
        image: sliderService1,
    },
    {
        badge: "FINTECH",
        title: "Fintech Platform Development",
        subtitle: "Secure, scalable and high-performance financial systems.",
        description:
            "We build robust fintech solutions with secure payment integrations and compliance-ready architectures.",
        tags: [
            "Digital Payments",
            "Fraud Detection",
            "Secure API Integrations",
        ],
        image: sliderService1,
    },
    {
        badge: "HEALTHCARE",
        title: "Healthcare Software Solutions",
        subtitle: "Reliable and compliant digital healthcare systems.",
        description:
            "HIPAA-compliant platforms with seamless integrations and high data security.",
        tags: [
            "EHR & EMR Systems",
            "Telemedicine Platforms",
            "Healthcare Analytics",
        ],
        image: sliderService1,
    },
];

export default function MLMSlider() {
    const [index, setIndex] = useState(0);

    const handlePrev = () => {
        setIndex((prev) => (prev === 0 ? slides.length - 1 : prev - 1));
    };

    const handleNext = () => {
        setIndex((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    };

    const slide = slides[index];

    return (
        <section className='padding-section-large '>
            <Container>
                <Row className='mb-4'>
                    <Col md={9}>
                        <h2 className="heading-style-h2 pb-3">Real Work, <span className="text-gradient-1">Real Systems</span></h2>
                        <h5 className='heading-style-h5 pb-5'>A look at how our services come together across different industries and real-world use cases. </h5>
                    </Col>
                </Row>
                <div className="mlm-slider-card">
                    <Row className="align-items-center">
                        {/* Left Image */}
                        <Col md={4} className="p-0">
                            <img
                                src={slide.image}
                                alt={slide.title}
                                className="mlm-slider-image"
                            />
                        </Col>

                        {/* Right Content */}
                        <Col md={8}>
                            <div className="mlm-slider-content">
                                <span className="mlm-badge bg-gradient-3">{slide.badge}</span>
                                <h4 className="heading-style-h4 my-3">{slide.title}</h4>
                                <h5 className="heading-style-h5 mb-3">{slide.subtitle}</h5>
                                <p className="mlm-description mb-3">{slide.description}</p>
                                <div className="mlm-tags">
                                    {slide.tags.map((tag, i) => (
                                        <span key={i}>{tag}</span>
                                    ))}
                                </div>

                                <Link className="btn btn-outline-dark rounded-pill text-uppercase">VIEW CASE STUDY</Link>
                            </div>
                        </Col>
                    </Row>
                </div>

                {/* Bottom Controls */}
                <div className="mlm-slider-controls">

                    {/* Dots */}
                    <div className="mlm-dots">
                        {slides.map((_, i) => (
                            <span
                                key={i}
                                className={`dot ${i === index ? "active" : ""}`}
                                onClick={() => setIndex(i)}
                            ></span>
                        ))}
                    </div>

                    {/* Navigation Buttons */}
                    <div className="mlm-nav-buttons">
                        <Link className="btn btn-outline-dark rounded-pill text-uppercase" onClick={handlePrev}>
                            PREVIOUS
                        </Link>
                        <Link className="btn btn-outline-dark rounded-pill text-uppercase" onClick={handleNext}>
                            NEXT
                        </Link>
                    </div>
                </div>
            </Container>
        </section>
    );
}